import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ConfirmAlert(props)
{
	return (
		<Dialog
			open={props.open}
			onClose={props.handleCancel}
			scroll={'paper'}
			aria-labelledby='scroll-dialog-title'
		>
			<DialogTitle id='scroll-dialog-title'>Confirmation</DialogTitle>
			<DialogContent dividers={'paper'}>
				<DialogContentText>
					{props.content}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.handleCancel} color='primary'>
					Cancel
				</Button>
				<Button onClick={props.handleOk} color='primary'>
					Yes
				</Button>
			</DialogActions>
		</Dialog>
	);
}